import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const mobile = state.user.mobile;

  if (isEmpty(mobile)) {
    return null;
  }

  if (isEmpty(mobile.mobile)) {
    return null;
  }

  return mobile.mobile;
};
//VERIFY IF THE JWT IS SET
const getMyMobileNumber = createSelector(getData, mobile => mobile);
export default getMyMobileNumber;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyMobileNumber.js